/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('../bootstrap2');
// require('./locale-all');
// window.Vue = require('vue');
window.$ = window.jQuery = $;
import Vue from 'vue';




// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'


import { BootstrapVue } from 'bootstrap-vue'
Vue.use(BootstrapVue)

let html = document.querySelector('html');
// {/* <html xmlns="http://www.w3.org/1999/xhtml" lang="zh-hk"></html> */}
// console.log("html", html.lang);


import VCalendar from 'v-calendar';
import 'v-calendar/lib/v-calendar.min.css';
window.moment = require('moment');

// import VeeValidate, { Validator } from 'vee-validate';
// Vue.use(VeeValidate);
// import zh_TW from 'vee-validate/dist/locale/zh_TW';
// Validator.localize('zh_TW', zh_TW);

if (html.lang == 'zh-hk') {
    Vue.use(VCalendar, {
        locales: {
            'zh-HK': {
                firstDayOfWeek: 1,
                masks: {
                    L: 'YYYY年MM月DD'
                },
                monthNames: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
                navVisibility: "hover"
            }
        }
    });
} else {
    Vue.use(VCalendar);
}


// Vue.component('school-calendar', require('./calendar/school-calendar.vue'));
Vue.component('home-calendar', require('./calendar/home-calendar.vue'));
Vue.component('full-calendar', require('./calendar/full-calendar.vue'));
// Vue.component('carousel', require('./carousel/Bootstrap4Carousel.vue'));
// Vue.component('timetable', require('./timetable/TimeTable.vue'));
// Vue.component('youtube', require('./google/youtube-channel.vue'));
// Vue.component('latest-news', require('./sections/latest-news.vue'));
// Vue.component('homework', require('./homework/Homework.vue'));
Vue.component('notice-list', require('./notice/noticeList.vue'));
Vue.component('spring-sermon', require('./church/sermon/sermons.vue'));
Vue.component('popup-modal', require('./popup-modal/Popup.vue'));
Vue.component('spring-calendar', require('./church/calendar/spring.vue'));



const app = new Vue({
    el: '#emgapp'
});



// WEBPACK FOOTER //
// ./resources/assets/js/mlang/app.js